import { RoundDirection } from '@/models/round-direction';

class Round {
  private _baseAngle: number = Math.PI;
  private _radius: number;
  private _count: number;
  private _angle: number = 0;
  private _sortDirection: number = 1;

  constructor(radius: number, count: number, direction?: RoundDirection, baseAngle?: number) {
    this._radius = radius;
    this._count = count - 1;
    if (baseAngle) this._baseAngle = baseAngle;

    switch (direction) {
      case RoundDirection.LEFT:
        this._angle = Math.PI;
        this._sortDirection = 1;
        break;
      case RoundDirection.TOP:
        this._angle = Math.PI * 1.5;
        this._sortDirection = 1;
        break;
      case RoundDirection.BOTTOM:
        this._angle = Math.PI / 2;
        this._sortDirection = 1;
        break;
      case RoundDirection.RIGHT:
        this._angle = Math.PI / 4 + Math.PI / 10;
        this._sortDirection = 1;
        break;
      default:
        this._angle = 0;
        this._sortDirection = -1;
        break;
    }
  }

  private getDeg(index: number) {
    return this._baseAngle / this._count * index;
  }

  private shiftX(deg: number) {
    return this._radius * Math.cos(deg);
  }

  private shiftY(deg: number) {
    return this._radius * Math.sin(deg)
  }

  public getShift(index: number) {
    const deg = this._sortDirection * this.getDeg(index) + this._angle;
    return {
      x: Math.round(this.shiftX(deg)),
      y: Math.round(this.shiftY(deg)),
      deg
    };
  }

  public getCenterShift(index: number, centerItemId: number) {
    const itemIndex = index - centerItemId;
    return this.getShift(itemIndex);
  }

}

export default Round;